module.exports = __webpack_public_path__ + "img/Hypoxia-GBM_SPATA.7bd4b25b.png";